import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "config/theme/baseTheme";

export const useStyles = makeStyles((theme) => ({
  header: {
    padding: theme.spacing(2),
    backgroundColor: COLORS.SELECTED_BLUE,
    color: COLORS.WHITE,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "8px 8px 0 0",
    flexShrink: 0,
  },
  title: {
    fontWeight: 600,
    fontSize: "15px",
  },
  content: {
    padding: theme.spacing(1.5),
    overflowY: "auto",
    flex: 1,
    backgroundColor: COLORS.WHITE,
  },
  suggestionCard: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: "6px",
  },
  orderHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  consignmentId: {
    fontWeight: 600,
    fontSize: "13px",
    color: COLORS.SELECTED_BLUE,
  },
  chip: {
    height: "20px",
    fontSize: "11px",
    fontWeight: 600,
  },
  infoRow: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: theme.spacing(0.5),
    fontSize: "12px",
  },
  icon: {
    fontSize: "16px",
    marginRight: theme.spacing(0.5),
    color: theme.palette.grey[800],
  },
  label: {
    color: theme.palette.grey[800],
    marginRight: theme.spacing(0.5),
  },
  value: {
    color: theme.palette.grey[700],
    flex: 1,
  },
  noDriver: {
    color: COLORS.ERROR_RED,
    fontStyle: "italic",
  },
  summaryBox: {
    padding: theme.spacing(1.5),
    backgroundColor: COLORS.LIGHTBLUE,
    borderRadius: "6px",
    marginBottom: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  summaryItem: {
    display: "flex",
    flexDirection: "column",
  },
  summaryItemLeft: {
    textAlign: "left",
  },
  summaryItemCenter: {
    textAlign: "center",
  },
  summaryItemRight: {
    textAlign: "right",
  },
  summaryLabel: {
    fontSize: 12,
    fontWeight: 600,
    display: "block",
  },
  summaryValue: {
    fontWeight: 600,
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(3),
    color: theme.palette.grey[300],
    fontSize: "13px",
  },
  addressContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  separator: {
    color: theme.palette.grey[700],
    margin: `0 ${theme.spacing(1)}px`,
  },
  itemsWeightRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(0.5),
    fontSize: "12px",
  },
}));
